import { THEME } from 'Assets/js/lib/constants'

const LOCALES = {
  CA: {
    name: 'Canada',
    iso_code: 'CA',
    region: 'North America',
    currency_iso_code: 'CAD',
    currency_symbol: '$',
  },
  US: {
    name: 'United States',
    iso_code: 'US',
    region: 'North America',
    currency_iso_code: 'USD',
    currency_symbol: '$',
    dev: 'https://dev-usa-saxx.myshopify.com/',
    prod: 'https://www.saxxunderwear.com/',
  },
  MX: {
    name: 'Mexico',
    iso_code: 'MX',
    region: 'North America',
    currency_iso_code: 'CAD',
    currency_symbol: '$',
  },
  AU: {
    name: 'Australia',
    iso_code: 'AU',
    region: 'Oceania',
    currency_iso_code: 'AUD',
    currency_symbol: '$',
  },
  AF: {
    name: 'Afghanistan',
    iso_code: 'AF',
    region: 'Asia',
    currency_iso_code: 'AFN',
    currency_symbol: '؋',
  },
  AX: {
    name: 'Åland Islands',
    iso_code: 'AX',
    region: 'Europe',
    currency_iso_code: 'EUR',
    currency_symbol: '€',
  },
  AL: {
    name: 'Albania',
    iso_code: 'AL',
    region: 'Europe',
    currency_iso_code: 'ALL',
    currency_symbol: 'L',
  },
  DZ: {
    name: 'Algeria',
    iso_code: 'DZ',
    region: 'Africa',
    currency_iso_code: 'DZD',
    currency_symbol: 'د.ج',
  },
  AD: {
    name: 'Andorra',
    iso_code: 'AD',
    region: 'Europe',
    currency_iso_code: 'EUR',
    currency_symbol: '€',
    dev: 'https://dev-eea-saxx.myshopify.com/',
    prod: 'https://www.saxxunderwear.eu/',
  },
  AO: {
    name: 'Angola',
    iso_code: 'AO',
    region: 'Africa',
    currency_iso_code: 'CAD',
    currency_symbol: '$',
  },
  AI: {
    name: 'Anguilla',
    iso_code: 'AI',
    region: 'Central America and Caribbean',
    currency_iso_code: 'XCD',
    currency_symbol: '$',
  },
  AG: {
    name: 'Antigua And Barbuda',
    iso_code: 'AG',
    region: 'Central America and Caribbean',
    currency_iso_code: 'CAD',
    currency_symbol: '$',
  },
  AR: {
    name: 'Argentina',
    iso_code: 'AR',
    region: 'South America',
    currency_iso_code: 'CAD',
    currency_symbol: '$',
  },
  AM: {
    name: 'Armenia',
    iso_code: 'AM',
    region: 'Asia',
    currency_iso_code: 'AMD',
    currency_symbol: 'դր.',
  },
  AW: {
    name: 'Aruba',
    iso_code: 'AW',
    region: 'Central America and Caribbean',
    currency_iso_code: 'AWG',
    currency_symbol: 'ƒ',
  },
  AC: {
    name: 'Ascension Island',
    iso_code: 'AC',
    region: 'Africa',
    currency_iso_code: 'SHP',
    currency_symbol: '£',
  },
  AT: {
    name: 'Austria',
    iso_code: 'AT',
    region: 'Europe',
    currency_iso_code: 'EUR',
    currency_symbol: '€',
    dev: 'https://dev-eea-saxx.myshopify.com/',
    prod: 'https://www.saxxunderwear.eu/',
  },
  AZ: {
    name: 'Azerbaijan',
    iso_code: 'AZ',
    region: 'Asia',
    currency_iso_code: 'AZN',
    currency_symbol: '₼',
  },
  BS: {
    name: 'Bahamas',
    iso_code: 'BS',
    region: 'Central America and Caribbean',
    currency_iso_code: 'BSD',
    currency_symbol: '$',
  },
  BH: {
    name: 'Bahrain',
    iso_code: 'BH',
    region: 'Asia',
    currency_iso_code: 'CAD',
    currency_symbol: '$',
  },
  BD: {
    name: 'Bangladesh',
    iso_code: 'BD',
    region: 'Asia',
    currency_iso_code: 'BDT',
    currency_symbol: '৳',
  },
  BB: {
    name: 'Barbados',
    iso_code: 'BB',
    region: 'Central America and Caribbean',
    currency_iso_code: 'BBD',
    currency_symbol: '$',
  },
  BE: {
    name: 'Belgium',
    iso_code: 'BE',
    region: 'Europe',
    currency_iso_code: 'EUR',
    currency_symbol: '€',
    dev: 'https://dev-eea-saxx.myshopify.com/',
    prod: 'https://www.saxxunderwear.eu/',
  },
  BZ: {
    name: 'Belize',
    iso_code: 'BZ',
    region: 'Central America and Caribbean',
    currency_iso_code: 'BZD',
    currency_symbol: '$',
  },
  BJ: {
    name: 'Benin',
    iso_code: 'BJ',
    region: 'Africa',
    currency_iso_code: 'XOF',
    currency_symbol: 'Fr',
  },
  BM: {
    name: 'Bermuda',
    iso_code: 'BM',
    region: 'Central America and Caribbean',
    currency_iso_code: 'USD',
    currency_symbol: '$',
  },
  BT: {
    name: 'Bhutan',
    iso_code: 'BT',
    region: 'Asia',
    currency_iso_code: 'CAD',
    currency_symbol: '$',
  },
  BO: {
    name: 'Bolivia',
    iso_code: 'BO',
    region: 'South America',
    currency_iso_code: 'BOB',
    currency_symbol: 'Bs',
  },
  BA: {
    name: 'Bosnia And Herzegovina',
    iso_code: 'BA',
    region: 'Europe',
    currency_iso_code: 'CAD',
    currency_symbol: '$',
  },
  BW: {
    name: 'Botswana',
    iso_code: 'BW',
    region: 'Africa',
    currency_iso_code: 'BWP',
    currency_symbol: 'P',
  },
  BR: {
    name: 'Brazil',
    iso_code: 'BR',
    region: 'South America',
    currency_iso_code: 'CAD',
    currency_symbol: '$',
  },
  IO: {
    name: 'British Indian Ocean Territory',
    iso_code: 'IO',
    region: 'Other Territories and Regions',
    currency_iso_code: 'USD',
    currency_symbol: '$',
  },
  VG: {
    name: 'Virgin Islands, British',
    iso_code: 'VG',
    region: 'Central America and Caribbean',
    currency_iso_code: 'USD',
    currency_symbol: '$',
  },
  BN: {
    name: 'Brunei',
    iso_code: 'BN',
    region: 'Asia',
    currency_iso_code: 'BND',
    currency_symbol: '$',
  },
  BG: {
    name: 'Bulgaria',
    iso_code: 'BG',
    region: 'Europe',
    currency_iso_code: 'BGN',
    currency_symbol: 'лв.',
    dev: 'https://dev-eea-saxx.myshopify.com/',
    prod: 'https://www.saxxunderwear.eu/',
  },
  BF: {
    name: 'Burkina Faso',
    iso_code: 'BF',
    region: 'Africa',
    currency_iso_code: 'BFA',
    currency_symbol: 'Fr',
  },
  BI: {
    name: 'Burundi',
    iso_code: 'BI',
    region: 'Africa',
    currency_iso_code: 'BIF',
    currency_symbol: 'Fr',
  },
  KH: {
    name: 'Cambodia',
    iso_code: 'KH',
    region: 'Asia',
    currency_iso_code: 'KHR',
    currency_symbol: '៛',
  },
  CM: {
    name: 'Republic of Cameroon',
    iso_code: 'CM',
    region: 'Africa',
    currency_iso_code: 'XAF',
    currency_symbol: 'CFA',
  },
  CV: {
    name: 'Cape Verde',
    iso_code: 'CV',
    region: 'Africa',
    currency_iso_code: 'CVE',
    currency_symbol: '$',
  },
  BQ: {
    name: 'Caribbean Netherlands',
    iso_code: 'BQ',
    region: 'Central America and Caribbean',
    currency_iso_code: 'USD',
    currency_symbol: '$',
  },
  KY: {
    name: 'Cayman Islands',
    iso_code: 'KY',
    region: 'Central America and Caribbean',
    currency_iso_code: 'KYD',
    currency_symbol: '$',
  },
  CF: {
    name: 'Central African Republic',
    iso_code: 'CF',
    region: 'Africa',
    currency_iso_code: 'XAF',
    currency_symbol: 'CFA',
  },
  TD: {
    name: 'Chad',
    iso_code: 'TD',
    region: 'Africa',
    currency_iso_code: 'XAF',
    currency_symbol: 'CFA',
  },
  CL: {
    name: 'Chile',
    iso_code: 'CL',
    region: 'South America',
    currency_iso_code: 'CAD',
    currency_symbol: '$',
  },
  CN: {
    name: 'China',
    iso_code: 'CN',
    region: 'Asia',
    currency_iso_code: 'CNY',
    currency_symbol: '¥',
  },
  CX: {
    name: 'Christmas Island',
    iso_code: 'CX',
    region: 'Oceania',
    currency_iso_code: 'AUD',
    currency_symbol: '$',
  },
  CC: {
    name: 'Cocos (Keeling) Islands',
    iso_code: 'CC',
    region: 'Oceania',
    currency_iso_code: 'AUD',
    currency_symbol: '$',
  },
  CO: {
    name: 'Colombia',
    iso_code: 'CO',
    region: 'South America',
    currency_iso_code: 'CAD',
    currency_symbol: '$',
  },
  KM: {
    name: 'Comoros',
    iso_code: 'KM',
    region: 'Africa',
    currency_iso_code: 'KMF',
    currency_symbol: 'Fr',
  },
  CG: {
    name: 'Congo',
    iso_code: 'CG',
    region: 'Africa',
    currency_iso_code: 'XAF',
    currency_symbol: 'CFA',
  },
  CD: {
    name: 'Congo, The Democratic Republic Of The',
    iso_code: 'CD',
    region: 'Africa',
    currency_iso_code: 'CDF',
    currency_symbol: 'Fr',
  },
  CK: {
    name: 'Cook Islands',
    iso_code: 'CK',
    region: 'Oceania',
    currency_iso_code: 'NZD',
    currency_symbol: '$',
  },
  CR: {
    name: 'Costa Rica',
    iso_code: 'CR',
    region: 'Central America and Caribbean',
    currency_iso_code: 'CRC',
    currency_symbol: '₡',
  },
  HR: {
    name: 'Croatia',
    iso_code: 'HR',
    region: 'Europe',
    currency_iso_code: 'EUR',
    currency_symbol: '€',
    dev: 'https://dev-eea-saxx.myshopify.com/',
    prod: 'https://www.saxxunderwear.eu/',
  },
  CW: {
    name: 'Curaçao',
    iso_code: 'CW',
    region: 'Central America and Caribbean',
    currency_iso_code: 'ANG',
    currency_symbol: 'ƒ',
  },
  CY: {
    name: 'Cyprus',
    iso_code: 'CY',
    region: 'Europe',
    currency_iso_code: 'EUR',
    currency_symbol: '€',
    dev: 'https://dev-eea-saxx.myshopify.com/',
    prod: 'https://www.saxxunderwear.eu/',
  },
  CZ: {
    name: 'Czechia',
    iso_code: 'CZ',
    region: 'Europe',
    currency_iso_code: 'CZK',
    currency_symbol: 'Kč',
    dev: 'https://dev-eea-saxx.myshopify.com/',
    prod: 'https://www.saxxunderwear.eu/',
  },
  CI: {
    name: "Côte d'Ivoire",
    iso_code: 'CI',
    region: 'Africa',
    currency_iso_code: 'XOF',
    currency_symbol: 'Fr',
  },
  DK: {
    name: 'Denmark',
    iso_code: 'DK',
    region: 'Europe',
    currency_iso_code: 'DKK',
    currency_symbol: 'kr.',
    dev: 'https://dev-eea-saxx.myshopify.com/',
    prod: 'https://www.saxxunderwear.eu/',
  },
  DJ: {
    name: 'Djibouti',
    iso_code: 'DJ',
    region: 'Africa',
    currency_iso_code: 'DJF',
    currency_symbol: 'Fdj',
  },
  DM: {
    name: 'Dominica',
    iso_code: 'DM',
    region: 'Central America and Caribbean',
    currency_iso_code: 'XCD',
    currency_symbol: '$',
  },
  DO: {
    name: 'Dominican Republic',
    iso_code: 'DO',
    region: 'Central America and Caribbean',
    currency_iso_code: 'DOP',
    currency_symbol: '$',
  },
  EC: {
    name: 'Ecuador',
    iso_code: 'EC',
    region: 'South America',
    currency_iso_code: 'USD',
    currency_symbol: '$',
  },
  EG: {
    name: 'Egypt',
    iso_code: 'EG',
    region: 'Africa',
    currency_iso_code: 'EGP',
    currency_symbol: 'ج.م',
  },
  SV: {
    name: 'El Salvador',
    iso_code: 'SV',
    region: 'Central America and Caribbean',
    currency_iso_code: 'USD',
    currency_symbol: '$',
  },
  GQ: {
    name: 'Equatorial Guinea',
    iso_code: 'GQ',
    region: 'Africa',
    currency_iso_code: 'XAF',
    currency_symbol: 'CFA',
  },
  ER: {
    name: 'Eritrea',
    iso_code: 'ER',
    region: 'Africa',
    currency_iso_code: 'ERN',
    currency_symbol: 'Nfk',
  },
  EE: {
    name: 'Estonia',
    iso_code: 'EE',
    region: 'Europe',
    currency_iso_code: 'EUR',
    currency_symbol: '€',
    dev: 'https://dev-eea-saxx.myshopify.com/',
    prod: 'https://www.saxxunderwear.eu/',
  },
  SZ: {
    name: 'Eswatini',
    iso_code: 'SZ',
    region: 'Africa',
    currency_iso_code: 'SZL',
    currency_symbol: 'E',
  },
  ET: {
    name: 'Ethiopia',
    iso_code: 'ET',
    region: 'Africa',
    currency_iso_code: 'ETB',
    currency_symbol: 'Br',
  },
  FK: {
    name: 'Falkland Islands (Malvinas)',
    iso_code: 'FK',
    region: 'Other Territories and Regions',
    currency_iso_code: 'FKP',
    currency_symbol: '£',
  },
  FO: {
    name: 'Faroe Islands',
    iso_code: 'FO',
    region: 'Europe',
    currency_iso_code: 'DKK',
    currency_symbol: 'kr.',
  },
  FJ: {
    name: 'Fiji',
    iso_code: 'FJ',
    region: 'Oceania',
    currency_iso_code: 'FJD',
    currency_symbol: '$',
  },
  FI: {
    name: 'Finland',
    iso_code: 'FI',
    region: 'Europe',
    currency_iso_code: 'EUR',
    currency_symbol: '€',
    dev: 'https://dev-eea-saxx.myshopify.com/',
    prod: 'https://www.saxxunderwear.eu/',
  },
  FR: {
    name: 'France',
    iso_code: 'FR',
    region: 'Europe',
    currency_iso_code: 'EUR',
    currency_symbol: '€',
    dev: 'https://dev-eea-saxx.myshopify.com/',
    prod: 'https://www.saxxunderwear.eu/',
  },
  GF: {
    name: 'French Guiana',
    iso_code: 'GF',
    region: 'South America',
    currency_iso_code: 'EUR',
    currency_symbol: '€',
  },
  PF: {
    name: 'French Polynesia',
    iso_code: 'PF',
    region: 'Oceania',
    currency_iso_code: 'XPF',
    currency_symbol: 'Fr',
  },
  TF: {
    name: 'French Southern Territories',
    iso_code: 'TF',
    region: 'Other Territories and Regions',
    currency_iso_code: 'EUR',
    currency_symbol: '€',
  },
  GA: {
    name: 'Gabon',
    iso_code: 'GA',
    region: 'Africa',
    currency_iso_code: 'XOF',
    currency_symbol: 'Fr',
  },
  GM: {
    name: 'Gambia',
    iso_code: 'GM',
    region: 'Africa',
    currency_iso_code: 'GMD',
    currency_symbol: 'D',
  },
  GE: {
    name: 'Georgia',
    iso_code: 'GE',
    region: 'Asia',
    currency_iso_code: 'CAD',
    currency_symbol: '$',
  },
  DE: {
    name: 'Germany',
    iso_code: 'DE',
    region: 'Europe',
    currency_iso_code: 'EUR',
    currency_symbol: '€',
    dev: 'https://dev-eea-saxx.myshopify.com/',
    prod: 'https://www.saxxunderwear.eu/',
  },
  GH: {
    name: 'Ghana',
    iso_code: 'GH',
    region: 'Africa',
    currency_iso_code: 'CAD',
    currency_symbol: '$',
  },
  GI: {
    name: 'Gibraltar',
    iso_code: 'GI',
    region: 'Europe',
    currency_iso_code: 'GBP',
    currency_symbol: '£',
  },
  GR: {
    name: 'Greece',
    iso_code: 'GR',
    region: 'Europe',
    currency_iso_code: 'EUR',
    currency_symbol: '€',
    dev: 'https://dev-eea-saxx.myshopify.com/',
    prod: 'https://www.saxxunderwear.eu/',
  },
  GL: {
    name: 'Greenland',
    iso_code: 'GL',
    region: 'North America',
    currency_iso_code: 'DKK',
    currency_symbol: 'kr.',
  },
  GD: {
    name: 'Grenada',
    iso_code: 'GD',
    region: 'Central America and Caribbean',
    currency_iso_code: 'XCD',
    currency_symbol: '$',
  },
  GP: {
    name: 'Guadeloupe',
    iso_code: 'GP',
    region: 'Central America and Caribbean',
    currency_iso_code: 'EUR',
    currency_symbol: '€',
  },
  GT: {
    name: 'Guatemala',
    iso_code: 'GT',
    region: 'Central America and Caribbean',
    currency_iso_code: 'GTQ',
    currency_symbol: 'Q',
  },
  GG: {
    name: 'Guernsey',
    iso_code: 'GG',
    region: 'Europe',
    currency_iso_code: 'GBP',
    currency_symbol: '£',
  },
  GN: {
    name: 'Guinea',
    iso_code: 'GN',
    region: 'Africa',
    currency_iso_code: 'GNF',
    currency_symbol: 'Fr',
  },
  GW: {
    name: 'Guinea Bissau',
    iso_code: 'GW',
    region: 'Africa',
    currency_iso_code: 'CAD',
    currency_symbol: '$',
  },
  GY: {
    name: 'Guyana',
    iso_code: 'GY',
    region: 'South America',
    currency_iso_code: 'GYD',
    currency_symbol: '$',
  },
  HT: {
    name: 'Haiti',
    iso_code: 'HT',
    region: 'Central America and Caribbean',
    currency_iso_code: 'CAD',
    currency_symbol: '$',
  },
  HN: {
    name: 'Honduras',
    iso_code: 'HN',
    region: 'Central America and Caribbean',
    currency_iso_code: 'HNL',
    currency_symbol: 'L',
  },
  HK: {
    name: 'Hong Kong SAR',
    iso_code: 'HK',
    region: 'Asia',
    currency_iso_code: 'HKD',
    currency_symbol: '$',
  },
  HU: {
    name: 'Hungary',
    iso_code: 'HU',
    region: 'Europe',
    currency_iso_code: 'HUF',
    currency_symbol: 'Ft',
    dev: 'https://dev-eea-saxx.myshopify.com/',
    prod: 'https://www.saxxunderwear.eu/',
  },
  IS: {
    name: 'Iceland',
    iso_code: 'IS',
    region: 'Europe',
    currency_iso_code: 'ISK',
    currency_symbol: 'kr',
    dev: 'https://dev-eea-saxx.myshopify.com/',
    prod: 'https://www.saxxunderwear.eu/',
  },
  IN: {
    name: 'India',
    iso_code: 'IN',
    region: 'Asia',
    currency_iso_code: 'INR',
    currency_symbol: '₹',
  },
  ID: {
    name: 'Indonesia',
    iso_code: 'ID',
    region: 'Asia',
    currency_iso_code: 'IDR',
    currency_symbol: 'Rp',
  },
  IQ: {
    name: 'Iraq',
    iso_code: 'IQ',
    region: 'Asia',
    currency_iso_code: 'CAD',
    currency_symbol: '$',
  },
  IE: {
    name: 'Ireland',
    iso_code: 'IE',
    region: 'Europe',
    currency_iso_code: 'EUR',
    currency_symbol: '€',
    dev: 'https://dev-eea-saxx.myshopify.com/',
    prod: 'https://www.saxxunderwear.eu/',
  },
  IM: {
    name: 'Isle Of Man',
    iso_code: 'IM',
    region: 'Europe',
    currency_iso_code: 'GBP',
    currency_symbol: '£',
  },
  IL: {
    name: 'Israel',
    iso_code: 'IL',
    region: 'Asia',
    currency_iso_code: 'ILS',
    currency_symbol: '₪',
  },
  IT: {
    name: 'Italy',
    iso_code: 'IT',
    region: 'Europe',
    currency_iso_code: 'EUR',
    currency_symbol: '€',
    dev: 'https://dev-eea-saxx.myshopify.com/',
    prod: 'https://www.saxxunderwear.eu/',
  },
  JM: {
    name: 'Jamaica',
    iso_code: 'JM',
    region: 'Central America and Caribbean',
    currency_iso_code: 'JMD',
    currency_symbol: '$',
  },
  JP: {
    name: 'Japan',
    iso_code: 'JP',
    region: 'Asia',
    currency_iso_code: 'JPY',
    currency_symbol: '¥',
  },
  JE: {
    name: 'Jersey',
    iso_code: 'JE',
    region: 'Europe',
    currency_iso_code: 'CAD',
    currency_symbol: '$',
  },
  JO: {
    name: 'Jordan',
    iso_code: 'JO',
    region: 'Asia',
    currency_iso_code: 'CAD',
    currency_symbol: '$',
  },
  KZ: {
    name: 'Kazakhstan',
    iso_code: 'KZ',
    region: 'Asia',
    currency_iso_code: 'KZT',
    currency_symbol: '₸',
  },
  KE: {
    name: 'Kenya',
    iso_code: 'KE',
    region: 'Africa',
    currency_iso_code: 'KES',
    currency_symbol: 'KSh',
  },
  KI: {
    name: 'Kiribati',
    iso_code: 'KI',
    region: 'Oceania',
    currency_iso_code: 'CAD',
    currency_symbol: '$',
  },
  XK: {
    name: 'Kosovo',
    iso_code: 'XK',
    region: 'Europe',
    currency_iso_code: 'EUR',
    currency_symbol: '€',
  },
  KW: {
    name: 'Kuwait',
    iso_code: 'KW',
    region: 'Asia',
    currency_iso_code: 'CAD',
    currency_symbol: '$',
  },
  KG: {
    name: 'Kyrgyzstan',
    iso_code: 'KG',
    region: 'Asia',
    currency_iso_code: 'KGS',
    currency_symbol: 'som',
  },
  LA: {
    name: "Lao People's Democratic Republic",
    iso_code: 'LA',
    region: 'Asia',
    currency_iso_code: 'LAK',
    currency_symbol: '₭',
  },
  LV: {
    name: 'Latvia',
    iso_code: 'LV',
    region: 'Europe',
    currency_iso_code: 'EUR',
    currency_symbol: '€',
    dev: 'https://dev-eea-saxx.myshopify.com/',
    prod: 'https://www.saxxunderwear.eu/',
  },
  LB: {
    name: 'Lebanon',
    iso_code: 'LB',
    region: 'Asia',
    currency_iso_code: 'LBP',
    currency_symbol: 'ل.ل',
  },
  LS: {
    name: 'Lesotho',
    iso_code: 'LS',
    region: 'Africa',
    currency_iso_code: 'CAD',
    currency_symbol: '$',
  },
  LR: {
    name: 'Liberia',
    iso_code: 'LR',
    region: 'Africa',
    currency_iso_code: 'CAD',
    currency_symbol: '$',
  },
  LI: {
    name: 'Liechtenstein',
    iso_code: 'LI',
    region: 'Europe',
    currency_iso_code: 'CHF',
    currency_symbol: 'CHF',
    dev: 'https://dev-eea-saxx.myshopify.com/',
    prod: 'https://www.saxxunderwear.eu/',
  },
  LT: {
    name: 'Lithuania',
    iso_code: 'LT',
    region: 'Europe',
    currency_iso_code: 'EUR',
    currency_symbol: '€',
    dev: 'https://dev-eea-saxx.myshopify.com/',
    prod: 'https://www.saxxunderwear.eu/',
  },
  LU: {
    name: 'Luxembourg',
    iso_code: 'LU',
    region: 'Europe',
    currency_iso_code: 'EUR',
    currency_symbol: '€',
    dev: 'https://dev-eea-saxx.myshopify.com/',
    prod: 'https://www.saxxunderwear.eu/',
  },
  MO: {
    name: 'Macao SAR',
    iso_code: 'MO',
    region: 'Asia',
    currency_iso_code: 'MOP',
    currency_symbol: 'P',
  },
  MG: {
    name: 'Madagascar',
    iso_code: 'MG',
    region: 'Africa',
    currency_iso_code: 'CAD',
    currency_symbol: '$',
  },
  MW: {
    name: 'Malawi',
    iso_code: 'MW',
    region: 'Africa',
    currency_iso_code: 'MWK',
    currency_symbol: 'MK',
  },
  MY: {
    name: 'Malaysia',
    iso_code: 'MY',
    region: 'Asia',
    currency_iso_code: 'MYR',
    currency_symbol: 'RM',
  },
  MV: {
    name: 'Maldives',
    iso_code: 'MV',
    region: 'Asia',
    currency_iso_code: 'MVR',
    currency_symbol: 'MVR',
  },
  ML: {
    name: 'Mali',
    iso_code: 'ML',
    region: 'Africa',
    currency_iso_code: 'XOF',
    currency_symbol: 'Fr',
  },
  MT: {
    name: 'Malta',
    iso_code: 'MT',
    region: 'Europe',
    currency_iso_code: 'EUR',
    currency_symbol: '€',
    dev: 'https://dev-eea-saxx.myshopify.com/',
    prod: 'https://www.saxxunderwear.eu/',
  },
  MQ: {
    name: 'Martinique',
    iso_code: 'MQ',
    region: 'Central America and Caribbean',
    currency_iso_code: 'EUR',
    currency_symbol: '€',
  },
  MR: {
    name: 'Mauritania',
    iso_code: 'MR',
    region: 'Africa',
    currency_iso_code: 'CAD',
    currency_symbol: '$',
  },
  MU: {
    name: 'Mauritius',
    iso_code: 'MU',
    region: 'Africa',
    currency_iso_code: 'MUR',
    currency_symbol: '₨',
  },
  YT: {
    name: 'Mayotte',
    iso_code: 'YT',
    region: 'Africa',
    currency_iso_code: 'EUR',
    currency_symbol: '€',
  },
  MD: {
    name: 'Moldova, Republic of',
    iso_code: 'MD',
    region: 'Europe',
    currency_iso_code: 'MDL',
    currency_symbol: 'L',
  },
  MC: {
    name: 'Monaco',
    iso_code: 'MC',
    region: 'Europe',
    currency_iso_code: 'EUR',
    currency_symbol: '€',
  },
  MN: {
    name: 'Mongolia',
    iso_code: 'MN',
    region: 'Asia',
    currency_iso_code: 'MNT',
    currency_symbol: '₮',
  },
  ME: {
    name: 'Montenegro',
    iso_code: 'ME',
    region: 'Europe',
    currency_iso_code: 'EUR',
    currency_symbol: '€',
  },
  MS: {
    name: 'Montserrat',
    iso_code: 'MS',
    region: 'Central America and Caribbean',
    currency_iso_code: 'XCD',
    currency_symbol: '$',
  },
  MA: {
    name: 'Morocco',
    iso_code: 'MA',
    region: 'Africa',
    currency_iso_code: 'MAD',
    currency_symbol: ' د.م.',
  },
  MZ: {
    name: 'Mozambique',
    iso_code: 'MZ',
    region: 'Africa',
    currency_iso_code: 'CAD',
    currency_symbol: '$',
  },
  MM: {
    name: 'Myanmar (Burma)',
    iso_code: 'MM',
    region: 'Asia',
    currency_iso_code: 'MMK',
    currency_symbol: 'K',
  },
  NA: {
    name: 'Namibia',
    iso_code: 'NA',
    region: 'Africa',
    currency_iso_code: 'CAD',
    currency_symbol: '$',
  },
  NR: {
    name: 'Nauru',
    iso_code: 'NR',
    region: 'Oceania',
    currency_iso_code: 'AUD',
    currency_symbol: '$',
  },
  NP: {
    name: 'Nepal',
    iso_code: 'NP',
    region: 'Asia',
    currency_iso_code: 'NPR',
    currency_symbol: 'Rs.',
  },
  NL: {
    name: 'Netherlands',
    iso_code: 'NL',
    region: 'Europe',
    currency_iso_code: 'EUR',
    currency_symbol: '€',
    dev: 'https://dev-eea-saxx.myshopify.com/',
    prod: 'https://www.saxxunderwear.eu/',
  },
  NC: {
    name: 'New Caledonia',
    iso_code: 'NC',
    region: 'Oceania',
    currency_iso_code: 'XPF',
    currency_symbol: 'Fr',
  },
  NZ: {
    name: 'New Zealand',
    iso_code: 'NZ',
    region: 'Oceania',
    currency_iso_code: 'NZD',
    currency_symbol: '$',
  },
  NI: {
    name: 'Nicaragua',
    iso_code: 'NI',
    region: 'Central America and Caribbean',
    currency_iso_code: 'NIO',
    currency_symbol: 'C$',
  },
  NE: {
    name: 'Niger',
    iso_code: 'NE',
    region: 'Africa',
    currency_iso_code: 'XOF',
    currency_symbol: 'Fr',
  },
  NG: {
    name: 'Nigeria',
    iso_code: 'NG',
    region: 'Africa',
    currency_iso_code: 'NGN',
    currency_symbol: '₦',
  },
  NU: {
    name: 'Niue',
    iso_code: 'NU',
    region: 'Oceania',
    currency_iso_code: 'NZD',
    currency_symbol: '$',
  },
  NF: {
    name: 'Norfolk Island',
    iso_code: 'NF',
    region: 'Oceania',
    currency_iso_code: 'AUD',
    currency_symbol: '$',
  },
  MK: {
    name: 'North Macedonia',
    iso_code: 'MK',
    region: 'Europe',
    currency_iso_code: 'MKD',
    currency_symbol: 'ден',
    dev: 'https://dev-eea-saxx.myshopify.com/',
    prod: 'https://www.saxxunderwear.eu/',
  },
  NO: {
    name: 'Norway',
    iso_code: 'NO',
    region: 'Europe',
    currency_iso_code: 'CAD',
    currency_symbol: '$',
    dev: 'https://dev-eea-saxx.myshopify.com/',
    prod: 'https://www.saxxunderwear.eu/',
  },
  OM: {
    name: 'Oman',
    iso_code: 'OM',
    region: 'Asia',
    currency_iso_code: 'CAD',
    currency_symbol: '$',
  },
  PK: {
    name: 'Pakistan',
    iso_code: 'PK',
    region: 'Asia',
    currency_iso_code: 'PKR',
    currency_symbol: '₨',
  },
  PS: {
    name: 'Palestinian Territories',
    iso_code: 'PS',
    region: 'Asia',
    currency_iso_code: 'ILS',
    currency_symbol: '₪',
  },
  PA: {
    name: 'Panama',
    iso_code: 'PA',
    region: 'Central America and Caribbean',
    currency_iso_code: 'USD',
    currency_symbol: '$',
  },
  PG: {
    name: 'Papua New Guinea',
    iso_code: 'PG',
    region: 'Oceania',
    currency_iso_code: 'PGK',
    currency_symbol: 'K',
  },
  PY: {
    name: 'Paraguay',
    iso_code: 'PY',
    region: 'South America',
    currency_iso_code: 'PYG',
    currency_symbol: '₲',
  },
  PE: {
    name: 'Peru',
    iso_code: 'PE',
    region: 'South America',
    currency_iso_code: 'PEN',
    currency_symbol: 'S/',
  },
  PH: {
    name: 'Philippines',
    iso_code: 'PH',
    region: 'Asia',
    currency_iso_code: 'PHP',
    currency_symbol: '₱',
  },
  PN: {
    name: 'Pitcairn',
    iso_code: 'PN',
    region: 'Other Territories and Regions',
    currency_iso_code: 'CAD',
    currency_symbol: '$',
  },
  PL: {
    name: 'Poland',
    iso_code: 'PL',
    region: 'Europe',
    currency_iso_code: 'PLN',
    currency_symbol: 'zł',
    dev: 'https://dev-eea-saxx.myshopify.com/',
    prod: 'https://www.saxxunderwear.eu/',
  },
  PT: {
    name: 'Portugal',
    iso_code: 'PT',
    region: 'Europe',
    currency_iso_code: 'EUR',
    currency_symbol: '€',
    dev: 'https://dev-eea-saxx.myshopify.com/',
    prod: 'https://www.saxxunderwear.eu/',
  },
  QA: {
    name: 'Qatar',
    iso_code: 'QA',
    region: 'Asia',
    currency_iso_code: 'QAR',
    currency_symbol: 'ر.ق',
  },
  RE: {
    name: 'Réunion',
    iso_code: 'RE',
    region: 'Africa',
    currency_iso_code: 'EUR',
    currency_symbol: '€',
  },
  RO: {
    name: 'Romania',
    iso_code: 'RO',
    region: 'Europe',
    currency_iso_code: 'RON',
    currency_symbol: 'Lei',
    dev: 'https://dev-eea-saxx.myshopify.com/',
    prod: 'https://www.saxxunderwear.eu/',
  },
  RW: {
    name: 'Rwanda',
    iso_code: 'RW',
    region: 'Africa',
    currency_iso_code: 'RWF',
    currency_symbol: 'FRw',
  },
  WS: {
    name: 'Samoa',
    iso_code: 'WS',
    region: 'Oceania',
    currency_iso_code: 'WST',
    currency_symbol: 'T',
  },
  SM: {
    name: 'San Marino',
    iso_code: 'SM',
    region: 'Europe',
    currency_iso_code: 'EUR',
    currency_symbol: '€',
  },
  ST: {
    name: 'São Tomé & Príncipe',
    iso_code: 'ST',
    region: 'Africa',
    currency_iso_code: 'STN',
    currency_symbol: 'Db',
  },
  SA: {
    name: 'Saudi Arabia',
    iso_code: 'SA',
    region: 'Asia',
    currency_iso_code: 'SAR',
    currency_symbol: 'ر.س',
  },
  SN: {
    name: 'Senegal',
    iso_code: 'SN',
    region: 'Africa',
    currency_iso_code: 'XOF',
    currency_symbol: 'Fr',
  },
  RS: {
    name: 'Serbia',
    iso_code: 'RS',
    region: 'Europe',
    currency_iso_code: 'RSD',
    currency_symbol: 'РСД',
  },
  SC: {
    name: 'Seychelles',
    iso_code: 'SC',
    region: 'Africa',
    currency_iso_code: 'CAD',
    currency_symbol: '$',
  },
  SL: {
    name: 'Sierra Leone',
    iso_code: 'SL',
    region: 'Africa',
    currency_iso_code: 'SLL',
    currency_symbol: 'Le',
  },
  SG: {
    name: 'Singapore',
    iso_code: 'SG',
    region: 'Asia',
    currency_iso_code: 'SGD',
    currency_symbol: '$',
  },
  SX: {
    name: 'Sint Maarten',
    iso_code: 'SX',
    region: 'Central America and Caribbean',
    currency_iso_code: 'ANG',
    currency_symbol: 'ƒ',
  },
  SK: {
    name: 'Slovakia',
    iso_code: 'SK',
    region: 'Europe',
    currency_iso_code: 'EUR',
    currency_symbol: '€',
    dev: 'https://dev-eea-saxx.myshopify.com/',
    prod: 'https://www.saxxunderwear.eu/',
  },
  SI: {
    name: 'Slovenia',
    iso_code: 'SI',
    region: 'Europe',
    currency_iso_code: 'EUR',
    currency_symbol: '€',
    dev: 'https://dev-eea-saxx.myshopify.com/',
    prod: 'https://www.saxxunderwear.eu/',
  },
  SB: {
    name: 'Solomon Islands',
    iso_code: 'SB',
    region: 'Oceania',
    currency_iso_code: 'SBD',
    currency_symbol: '$',
  },
  ZA: {
    name: 'South Africa',
    iso_code: 'ZA',
    region: 'Africa',
    currency_iso_code: 'CAD',
    currency_symbol: '$',
  },
  GS: {
    name: 'South Georgia & The South Sandwich Islands',
    iso_code: 'GS',
    region: 'Other Territories and Regions',
    currency_iso_code: 'GBP',
    currency_symbol: '£',
  },
  KR: {
    name: 'South Korea',
    iso_code: 'KR',
    region: 'Asia',
    currency_iso_code: 'KRW',
    currency_symbol: '₩',
  },
  ES: {
    name: 'Spain',
    iso_code: 'ES',
    region: 'Europe',
    currency_iso_code: 'EUR',
    currency_symbol: '€',
    dev: 'https://dev-eea-saxx.myshopify.com/',
    prod: 'https://www.saxxunderwear.eu/',
  },
  LK: {
    name: 'Sri Lanka',
    iso_code: 'LK',
    region: 'Asia',
    currency_iso_code: 'LKR',
    currency_symbol: 'Rs',
  },
  BL: {
    name: 'Saint Barthélemy',
    iso_code: 'BL',
    region: 'Central America and Caribbean',
    currency_iso_code: 'EUR',
    currency_symbol: '€',
  },
  SH: {
    name: 'Saint Helena',
    iso_code: 'SH',
    region: 'Africa',
    currency_iso_code: 'SHP',
    currency_symbol: '£',
  },
  KN: {
    name: 'Saint Kitts & Nevis',
    iso_code: 'KN',
    region: 'Central America and Caribbean',
    currency_iso_code: 'XCD',
    currency_symbol: '$',
  },
  LC: {
    name: 'Saint Lucia',
    iso_code: 'LC',
    region: 'Central America and Caribbean',
    currency_iso_code: 'XCD',
    currency_symbol: '$',
  },
  MF: {
    name: 'Saint Martin',
    iso_code: 'MF',
    region: 'Central America and Caribbean',
    currency_iso_code: 'EUR',
    currency_symbol: '€',
  },
  PM: {
    name: 'Saint Pierre & Miquelon',
    iso_code: 'PM',
    region: 'North America',
    currency_iso_code: 'CAD',
    currency_symbol: '$',
  },
  VC: {
    name: 'Saint Vincent & Grenadines',
    iso_code: 'VC',
    region: 'Central America and Caribbean',
    currency_iso_code: 'CAD',
    currency_symbol: '$',
  },
  SD: {
    name: 'Sudan',
    iso_code: 'SD',
    region: 'Africa',
    currency_iso_code: 'CAD',
    currency_symbol: '$',
  },
  SR: {
    name: 'Suriname',
    iso_code: 'SR',
    region: 'South America',
    currency_iso_code: 'CAD',
    currency_symbol: '$',
  },
  SJ: {
    name: 'Svalbard And Jan Mayen',
    iso_code: 'SJ',
    region: 'Europe',
    currency_iso_code: 'CAD',
    currency_symbol: '$',
  },
  SE: {
    name: 'Sweden',
    iso_code: 'SE',
    region: 'Europe',
    currency_iso_code: 'SEK',
    currency_symbol: 'kr',
    dev: 'https://dev-eea-saxx.myshopify.com/',
    prod: 'https://www.saxxunderwear.eu/',
  },
  CH: {
    name: 'Switzerland',
    iso_code: 'CH',
    region: 'Europe',
    currency_iso_code: 'CHF',
    currency_symbol: 'CHF',
    dev: 'https://dev-eea-saxx.myshopify.com/',
    prod: 'https://www.saxxunderwear.eu/',
  },
  TW: {
    name: 'Taiwan',
    iso_code: 'TW',
    region: 'Asia',
    currency_iso_code: 'TWD',
    currency_symbol: '$',
  },
  TJ: {
    name: 'Tajikistan',
    iso_code: 'TJ',
    region: 'Asia',
    currency_iso_code: 'TJS',
    currency_symbol: 'SM',
  },
  TZ: {
    name: 'Tanzania, United Republic Of',
    iso_code: 'TZ',
    region: 'Africa',
    currency_iso_code: 'TZS',
    currency_symbol: 'Sh',
  },
  TH: {
    name: 'Thailand',
    iso_code: 'TH',
    region: 'Asia',
    currency_iso_code: 'THB',
    currency_symbol: '฿',
  },
  TL: {
    name: 'Timor Leste',
    iso_code: 'TL',
    region: 'Asia',
    currency_iso_code: 'USD',
    currency_symbol: '$',
  },
  TG: {
    name: 'Togo',
    iso_code: 'TG',
    region: 'Africa',
    currency_iso_code: 'XOF',
    currency_symbol: 'Fr',
  },
  TK: {
    name: 'Tokelau',
    iso_code: 'TK',
    region: 'Oceania',
    currency_iso_code: 'NZD',
    currency_symbol: '$',
  },
  TO: {
    name: 'Tonga',
    iso_code: 'TO',
    region: 'Oceania',
    currency_iso_code: 'TOP',
    currency_symbol: 'T$',
  },
  TT: {
    name: 'Trinidad & Tobago',
    iso_code: 'TT',
    region: 'Central America and Caribbean',
    currency_iso_code: 'CAD',
    currency_symbol: '$',
  },
  TC: {
    name: 'Turks & Caicos Islands',
    iso_code: 'TC',
    region: 'Central America and Caribbean',
    currency_iso_code: 'USD',
    currency_symbol: '$',
  },
  TN: {
    name: 'Tunisia',
    iso_code: 'TN',
    region: 'Africa',
    currency_iso_code: 'CAD',
    currency_symbol: '$',
  },
  TR: {
    name: 'Turkey',
    iso_code: 'TR',
    region: 'Asia',
    currency_iso_code: 'CAD',
    currency_symbol: '$',
  },
  TM: {
    name: 'Turkmenistan',
    iso_code: 'TM',
    region: 'Asia',
    currency_iso_code: 'CAD',
    currency_symbol: '$',
  },
  TV: {
    name: 'Tuvalu',
    iso_code: 'TV',
    region: 'Oceania',
    currency_iso_code: 'AUD',
    currency_symbol: '$',
  },
  UG: {
    name: 'Uganda',
    iso_code: 'UG',
    region: 'Africa',
    currency_iso_code: 'UGX',
    currency_symbol: 'USh',
  },
  UA: {
    name: 'Ukraine',
    iso_code: 'UA',
    region: 'Europe',
    currency_iso_code: 'UAH',
    currency_symbol: '₴',
  },
  AE: {
    name: 'United Arab Emirates',
    iso_code: 'AE',
    region: 'Asia',
    currency_iso_code: 'AED',
    currency_symbol: 'د.إ',
  },
  GB: {
    name: 'United Kingdom',
    iso_code: 'GB',
    region: 'Europe',
    currency_iso_code: 'GBP',
    currency_symbol: '£',
    dev: 'https://dev-eea-saxx.myshopify.com/',
    prod: 'https://www.saxxunderwear.eu/',
  },
  UY: {
    name: 'Uruguay',
    iso_code: 'UY',
    region: 'South America',
    currency_iso_code: 'UYU',
    currency_symbol: '$',
  },
  UZ: {
    name: 'Uzbekistan',
    iso_code: 'UZ',
    region: 'Asia',
    currency_iso_code: 'UZS',
    currency_symbol: "so'm",
  },
  VU: {
    name: 'Vanuatu',
    iso_code: 'VU',
    region: 'Oceania',
    currency_iso_code: 'VUV',
    currency_symbol: 'Vt',
  },
  VA: {
    name: 'Holy See (Vatican City State)',
    iso_code: 'VA',
    region: 'Europe',
    currency_iso_code: 'EUR',
    currency_symbol: '€',
  },
  VE: {
    name: 'Venezuela',
    iso_code: 'VE',
    region: 'South America',
    currency_iso_code: 'USD',
    currency_symbol: '$',
  },
  VN: {
    name: 'Vietnam',
    iso_code: 'VN',
    region: 'Asia',
    currency_iso_code: 'VND',
    currency_symbol: '₫',
  },
  WF: {
    name: 'Wallis & Futuna',
    iso_code: 'WF',
    region: 'Oceania',
    currency_iso_code: 'XPF',
    currency_symbol: 'Fr',
  },
  EH: {
    name: 'Western Sahara',
    iso_code: 'EH',
    region: 'Africa',
    currency_iso_code: 'MAD',
    currency_symbol: 'د.م.',
  },
  ZM: {
    name: 'Zambia',
    iso_code: 'ZM',
    region: 'Africa',
    currency_iso_code: 'CAD',
    currency_symbol: '$',
  },
  ZW: {
    name: 'Zimbabwe',
    iso_code: 'ZW',
    region: 'Africa',
    currency_iso_code: 'USD',
    currency_symbol: '$',
  },
}
const SEARCHLOCALES = Object.values(LOCALES)

;(function () {
  let countryListHasBeenProcessed = false
  const EVENTS = {
    populateRegionList: 'locationVerification:populateRegionList',
    regionSearchEvent: 'locationVerification:regionSearchEvent',
    regionChange: 'locationVerification:regionChange',
  }
  const isProd = !(
    window.location.origin.includes('dev') ||
    window.location.host.includes('127')
  )

  const countryItemTemplate = (
    country,
    active = false,
  ) => `<li class='country-item text--small ${active ? 'active' : ''}' data-iso-code='${country.iso_code}'>
    <img
      src='https://cdn.shopify.com/static/images/flags/${country.iso_code.toLowerCase()}.svg?width=24'
      alt='${country.name}'
      width='24'
      height='18'
    >
    <p class='text--small'>${country.name} (${country.currency_iso_code} ${country.currency_symbol})</p>
  </li>`

  const components = {
    regionSelectorTrigger: SAXX.Init.Component((node, ctx) => {
      node.addEventListener('click', () => {
        if (node.disabled) return

        if (!countryListHasBeenProcessed) {
          ctx.emit(EVENTS.populateRegionList)
        }

        ctx.emit(THEME.modalControlInteraction, null, {
          controlElement: 'region-selector',
        })
      })

      node.disabled = false
    }),
    regionForm: SAXX.Init.Component((node, ctx) => {
      const submitButton = node.querySelector('#region-submit-button')
      const changeButton = node.querySelector('#region-change-button')
      const disclaimer = node.querySelector('#region-disclaimer')

      ctx.on(EVENTS.regionChange, (_, { isoCode }) => {
        const target = LOCALES[isoCode]
        node.querySelector('#country_code').value = isoCode

        if (!Object.prototype.hasOwnProperty.call(target, 'dev')) {
          target.dev = 'https://dev-ca-saxx.myshopify.com/'
          target.prod = 'https://www.saxxunderwear.ca/'
        }

        const url = new URL(isProd ? target.prod : target.dev)
        url.searchParams.append('cross_entrance', 'true')
        changeButton.href = url.toString()

        submitButton.querySelector('.target-site').innerHTML =
          `${target.name} &ndash; ${target.currency_iso_code}&nbsp;(${target.currency_symbol})`
        changeButton.querySelector('.target-site').innerHTML =
          `${target.name} &ndash; ${target.currency_iso_code}&nbsp;(${target.currency_symbol})`

        disclaimer.classList.toggle(
          'hidden',
          url.hostname === window.location.hostname,
        )

        submitButton.classList.toggle(
          'hidden',
          url.hostname !== window.location.hostname,
        )
        changeButton.classList.toggle(
          'hidden',
          url.hostname === window.location.hostname,
        )
      })

      submitButton.addEventListener('click', (e) => {
        e.preventDefault()
        e.target.closest('form').submit()
      })
    }),
    regionCountrySearchInput: SAXX.Init.Component((node, ctx) => {
      node.addEventListener('input', () => {
        ctx.emit(EVENTS.regionSearchEvent, null, { searchValue: node.value })
      })
    }),
    regionCountryList: SAXX.Init.Component((node, ctx) => {
      ctx.on(EVENTS.populateRegionList, () => {
        countryListHasBeenProcessed = true
        SEARCHLOCALES.forEach((country) => {
          const region = node.querySelector(
            `ul[data-region="${country.region}"]`,
          )
          region.insertAdjacentHTML(
            'beforeend',
            countryItemTemplate(country, Shopify.country === country.iso_code),
          )
        })

        const countryItemList = Array.from(
          node.querySelectorAll('.country-item'),
        )

        countryItemList.forEach((element) => {
          element.addEventListener('click', () => {
            countryItemList.forEach((item) => item.classList.remove('active'))

            element.classList.add('active')

            ctx.emit(EVENTS.regionChange, null, {
              isoCode: element.getAttribute('data-iso-code'),
            })
          })
        })
      })

      ctx.on(EVENTS.regionSearchEvent, (_, { searchValue }) => {
        node.classList.toggle('hidden', Array.from(searchValue).length > 0)
      })
    }),
    regionCountrySearchResults: SAXX.Init.Component((node, ctx) => {
      ctx.on(EVENTS.regionSearchEvent, (_, { searchValue }) => {
        node.innerHTML = ''
        if (Array.from(searchValue).length < 1) return

        const search = searchValue.toLowerCase()

        SEARCHLOCALES.forEach((country) => {
          if (!country.name.toLowerCase().includes(search)) return
          node.insertAdjacentHTML('beforeend', countryItemTemplate(country))
        })

        const countryItemList = Array.from(
          node.querySelectorAll('.country-item'),
        )

        countryItemList.forEach((element) => {
          element.addEventListener('click', () => {
            countryItemList.forEach((item) => item.classList.remove('active'))

            element.classList.add('active')

            ctx.emit(EVENTS.regionChange, null, {
              isoCode: element.getAttribute('data-iso-code'),
            })
          })
        })
      })
    }),
    languageSelectorSegment: SAXX.Init.Component((node, ctx) => {
      const languageSelectorType = node.getAttribute('data-type') === 'weglot'
      ctx.on(EVENTS.regionChange, (_, { isoCode }) => {
        const target = LOCALES[isoCode]
        if (!Object.prototype.hasOwnProperty.call(target, 'dev')) {
          target.dev = 'https://dev-ca-saxx.myshopify.com/'
          target.prod = 'https://www.saxxunderwear.ca/'
        }

        node.querySelector('.target-site').innerHTML = target.name

        const url = new URL(isProd ? target.prod : target.dev)
        const localeTest =
          languageSelectorType ?
            url.hostname !== window.location.hostname
          : isoCode.toLowerCase() !== Shopify.country.toLowerCase()

        node.classList.toggle('hidden', localeTest)
      })
    }),
    languageForm: SAXX.Init.Component((node) => {
      const language = node.querySelector('#language_code')
      language.addEventListener('change', () => {
        node.submit()
      })
    }),
    weglotSwitcher: SAXX.Init.Component((node, ctx) => {
      const updateUX = () => {
        const languages = Weglot.getAvailableLanguages()

        languages.forEach((language) => {
          const matchingLang = Array.from(node.options).some(
            (option) => option.value.toLowerCase() === language.toLowerCase(),
          )

          if (!matchingLang) {
            const option = document.createElement('option')
            option.value = language
            option.textContent = Weglot.getLanguageName(language)

            node.appendChild(option)
          }
        })

        node.value = Weglot.getCurrentLang()
      }

      ctx.on('weglot:initialized', updateUX)

      if (typeof Weglot === 'object' && Weglot?.initialized) updateUX()

      node.addEventListener('change', (e) => {
        Weglot.switchTo(e.target.value.toLowerCase())
      })
    }),
    locationVerification: SAXX.Init.Component((node, ctx) => {
      const setOptOut = () => {
        window.sessionStorage.setItem('saxxCrossInstanceSession', 'true')
      }

      if (window.location.search.includes('cross_entrance=true')) {
        setOptOut()
      }

      node
        .closest('.modal')
        .querySelectorAll('[data-modal-close]')
        .forEach((ele) => {
          ele.addEventListener('click', () => {
            setOptOut()
          })
        })

      node.addEventListener('keydown', (e) => {
        const isEscPressed = e.key === 'Escape' || e.keyCode === 27
        if (!isEscPressed) return

        setOptOut()
      })

      ctx.on(
        THEME.userLocationIsSet,
        ({ location: { countryCode, currency } }) => {
          if (window.location.search.includes('cross_entrance=true')) return
          if (window.sessionStorage.getItem('saxxCrossInstanceSession')) return
          if (countryCode === window.Shopify.country) return

          let target = LOCALES[countryCode.toUpperCase()]

          if (!Object.prototype.hasOwnProperty.call(target, 'dev')) {
            target = {
              dev: 'https://dev-ca-saxx.myshopify.com/',
              prod: 'https://www.saxxunderwear.ca/',
            }
          }

          const url = new URL(isProd ? target.prod : target.dev)
          url.searchParams.append('cross_entrance', 'true')

          if (url.hostname === window.location.hostname) return

          const primaryLang = new Intl.Locale('und', {
            region: countryCode,
          }).maximize().language
          const regionName = new Intl.DisplayNames([primaryLang], {
            type: 'region',
          }).of(countryCode)
          const currencySymbol = new Intl.NumberFormat(
            `${primaryLang}-${countryCode}`,
            {
              style: 'currency',
              currencyDisplay: 'symbol',
              currency: currency.code,
            },
          )
            .formatToParts(1)
            .filter((item) => item.type === 'currency')
            .pop()

          node.querySelector('.localized-site').innerHTML =
            `${regionName} &ndash; ${currency.code}&nbsp;(${currencySymbol.value})?`

          node.querySelector('#location-verification-link').href =
            url.toString()

          ctx.emit(THEME.modalControlInteraction, null, {
            controlElement: 'location-verification',
          })
        },
      )
    }),
  }

  Object.assign(SAXX.Init.Components, components)
})()
